import { useSelector } from 'react-redux'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import { formatDateAndTime } from '../../util/formatDateAndTime'
import { EVENT_CATEGORIES } from '../../util/constants'
import CalendarSync from '../atoms/CalendarSync/CalendarSync.jsx'

export const QuickInfoTemplate = (props) => {
	const venues = useSelector((state) => state.kazooEvent.kazooVenues)
	
	return (
		<div>
			{props.elementType === 'cell' ? (
				<div className="e-cell-content e-template">
					<form className="e-schedule-form">
						<label htmlFor="eventQ" className="e-textlabel">
							Event
						</label>
						<input
							id="eventQ"
							className="subject e-field e-input"
							type="text"
							name="Subject"
						/>
						<label htmlFor="locationQ" className="e-textlabel">
							Location
						</label>
						<DropDownListComponent
							id="locationQ"
							name="Location"
							className="e-field"
							dataSource={venues}
							placeholder="Select location"
							mode="Default"
							data-cy="location-dropdown"
						/>

						<label htmlFor="eventCategoryQ" className="e-textlabel">
							Event Category *
						</label>
						<DropDownListComponent
							id="eventCategoryQ"
							name="EventCategory"
							className="e-field"
							dataSource={EVENT_CATEGORIES}
							placeholder="Select event category"
							mode="Default"
						/>

						<label htmlFor="eventColorQ" className="e-textlabel">
							Event Color
						</label>
						<div className="color-picker-wrapper">
							<DropDownListComponent
								id="eventColorQ"
								name="EventColor"
								dataSource={[
									{ name: 'Default', color: '#dfeef4' },
									{
										name: 'Light Pink',
										color: '#FFC0CB',
									},
									{
										name: 'Light Green',
										color: '#98FB98',
									},
								]}
								fields={{ text: 'name', value: 'color' }}
								value={props.EventColor || '#dfeef4'}
								itemTemplate={(data) => (
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											padding: '8px',
										}}
									>
										<span
											style={{
												display: 'inline-block',
												width: '18px',
												height: '18px',
												backgroundColor: data.color,
												border: '1px solid #ccc',
											}}
										></span>
										<span>{data.name}</span>
									</div>
								)}
								placeholder="Select event color"
								popupHeight="250px"
								className="e-field color-picker"
							/>
						</div>

						<label htmlFor="descriptionQ" className="e-textlabel">
							Description
						</label>
						<textarea
							id="descriptionQ"
							className="e-field e-input"
							name="Description"
							rows={3}
							defaultValue={props.Description}
						></textarea>

						<CalendarSync
							formMode
							defaultValues={props.syncToCalendar}
							showLabel={true}
							labelClassName="e-textlabel"
						/>

						<label htmlFor="lockedQ" className="e-textlabel">
							Locked
						</label>
						<input
							id="lockedQ"
							type="checkbox"
							name="Locked"
							className="e-field checkbox"
						/>
					</form>
				</div>
			) : (
				<div className="e-event-content e-template event-detail-modal-wrp">
					<div
						className="e-subject-wrap"
						style={{
							borderLeft: `5px solid ${props.EventColor || '#3498db'}`,
							paddingLeft: '12px',
						}}
					>
						{props.StartTime && (
							<div className="e-subject">
								<img
									src="/images/calendar.svg"
									alt="calendar"
									width={20}
									height={20}
								/>
								<h4>{formatDateAndTime(props)}</h4>
							</div>
						)}
						{props.Location && (
							<div className="e-subject">
								<img
									src="/images/location-1.svg"
									alt="location"
									width={20}
									height={20}
								/>
								<h4>{props.Location}</h4>
							</div>
						)}
						{props.Budget && (
							<div className="e-subject">
								<img
									src="/images/budget.svg"
									alt="budget"
									width={20}
									height={20}
								/>
								<h4>${props.Budget} CAD</h4>
							</div>
						)}
						{props.Description && (
							<div className="e-subject">
								<img
									src="/images/description-icon.svg"
									alt="description"
									width={20}
									height={20}
								/>
								<h4>{props.Description}</h4>
							</div>
						)}
						{props.Requirements && (
							<div className="e-subject">
								<img
									src="/images/tick-circle.svg"
									alt="requirements"
									width={20}
									height={20}
								/>
								<h4>{props.Requirements}</h4>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
